import { IFormField } from "src/library/components/Forms";

/**
 * @description Parses support ticket form question data into a human readable HTML string designed to be appended to a support ticket submission.
 *
 * Ignores attachments as they are handled separately.
 *
 * @param {IFormField[]} formFields - Form fields
 * @param {object} formValues - Form value answer object
 *
 * @returns {string} The support ticket answers interpolated into a string.
 */
export function parseSupportTicketExtraDataFormAnswers(
  formFields: IFormField[],
  formValues: object
): string {
  let response = "";

  Object.keys(formValues).map(formValueKey => {
    const formField = formFields.find(field => field.name === formValueKey);

    if (formField && formField.type !== "attachments") {
      response += `<p>${formField.label}: ${formValues[ formValueKey ]}</p>`;
    }
  });

  return response;
}